import Enums from 'utils/EnumsManager';

const { REPORT } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_SETTING_INFO = `${REPORT}_SET_SETTING_INFO`;



// WEBPACK FOOTER //
// ./src/views/RealTimeReport/flow/actionTypes.js